import { useEffect, useState } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import routes from '../_routes/app-routes.js';
import fetchDynamicRoutes from '../_routes/dynamic-routes.js';

const divisionCodes = ["RVR", "AUD", "TXC"];

const useMeta = () => {
    const location = useLocation();
    const [meta, setMeta] = useState();

    useEffect(() => {
        const fetchMeta = async () => {
            const allRoutes = [...routes];

            // Wait for all fetches to complete
            const dynamicRouteArrays = await Promise.all(
                divisionCodes.map(code => fetchDynamicRoutes(code))
            );

            dynamicRouteArrays.forEach(fetched => {
                if (Array.isArray(fetched)) {
                    allRoutes.push(...fetched);
                }
            });
            allRoutes.sort((a, b) => b.path.length - a.path.length);
            const currentPage = location.pathname;

            const currentRoute = allRoutes.find(route => {
                const matched = matchPath(
                    { path: route.path, end: true },
                    currentPage
                );
                return matched;
            });

            setMeta(currentRoute?.meta || {
                title: 'Default Title',
                description: 'Default description',
            });
        };

        fetchMeta();
    }, [location.pathname]);

    return meta;
};

export default useMeta;
